// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UXqlu_M87DrKdAeWy2OG .seuIw3TZAdObLI_NYtNa{display:flex;justify-content:space-between}", "",{"version":3,"sources":["webpack://./src/product/product-finder/product-finder.module.scss"],"names":[],"mappings":"AACE,4CACE,YAAA,CACA,6BAAA","sourcesContent":[".host {\n  .row {\n    display: flex;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"host": "UXqlu_M87DrKdAeWy2OG",
	"row": "seuIw3TZAdObLI_NYtNa"
};
export default ___CSS_LOADER_EXPORT___;
